import { render } from "./ProjectDetail.vue?vue&type=template&id=519667f5&scoped=true&ts=true"
import script from "./ProjectDetail.ts?vue&type=script&lang=ts"
export * from "./ProjectDetail.ts?vue&type=script&lang=ts"

import "./ProjectDetail.scss?vue&type=style&index=0&id=519667f5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519667f5"]])

export default __exports__